import { syncBlock as syncBlockFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils';

/**
 * Represents a block node that is designed to be synchronized
 * with an external resource across different products.
 * @name syncBlock_node
 */

export var syncBlock = syncBlockFactory({
  parseDOM: [{
    tag: 'div[data-sync-block]',
    getAttrs: function getAttrs(domNode) {
      var dom = domNode;
      var attrs = {
        localId: dom.getAttribute('data-local-id') || uuid.generate(),
        resourceId: dom.getAttribute('data-resource-id') || ''
      };
      return attrs;
    }
  }],
  toDOM: function toDOM(node) {
    var _node$attrs = node.attrs,
      localId = _node$attrs.localId,
      resourceId = _node$attrs.resourceId;
    var name = 'div';
    var attrs = {
      'data-sync-block': '',
      'data-local-id': localId,
      'data-resource-id': resourceId
    };
    return [name, attrs];
  }
});